import { render, staticRenderFns } from "./BattleAcademiaGameInfo.vue?vue&type=template&id=7b971da1&"
import script from "./BattleAcademiaGameInfo.vue?vue&type=script&lang=js&"
export * from "./BattleAcademiaGameInfo.vue?vue&type=script&lang=js&"
import style0 from "./BattleAcademiaGameInfo.vue?vue&type=style&index=0&id=7b971da1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports